var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLeftArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_949",
    "data-name": "Group 949",
    transform: "translate(45.054) rotate(90)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_519",
    "data-name": "Rectangle 519",
    width: 45,
    height: 45,
    transform: "translate(0 0.054)",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_946",
    "data-name": "Group 946",
    transform: "translate(15.362 11.402)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-arrow-up",
    "data-name": "Icon ionic-ios-arrow-up",
    d: "M6.821,2.35l5.156,5.16a.975.975,0,1,0,1.376-1.38L7.511.284A.973.973,0,0,0,6.167.255L.284,6.126a.975.975,0,0,0,1.376,1.38Z",
    transform: "translate(13.638 7.797) rotate(180)",
    fill: "#ffca65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-arrow-up-2",
    "data-name": "Icon ionic-ios-arrow-up",
    d: "M6.821,2.35l5.156,5.16a.975.975,0,1,0,1.376-1.38L7.511.284A.973.973,0,0,0,6.167.255L.284,6.126a.975.975,0,0,0,1.376,1.38Z",
    transform: "translate(13.638 15.594) rotate(180)",
    fill: "#ffca65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-arrow-up-3",
    "data-name": "Icon ionic-ios-arrow-up",
    d: "M6.821,2.35l5.156,5.16a.975.975,0,1,0,1.376-1.38L7.511.284A.973.973,0,0,0,6.167.255L.284,6.126a.975.975,0,0,0,1.376,1.38Z",
    transform: "translate(13.638 23.391) rotate(180)",
    fill: "#ffca65"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/leftArrow.e38514e6ac8c85b5b835ba0e797af719.svg";
export { ForwardRef as ReactComponent };